import { Loadable } from 'loankeeper-common/components/hocs/LazyLoading'

import { ClientRiskLevelAddTrigger } from './ClientRiskLevelAdd'

export { ClientRiskLevelAddTrigger }

export default Loadable(() => import('./ClientRiskLevelAdd'))
